/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Checkbox } from 'antd';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import ButtonComponent from '../../../components/button';

const ChartReport = ({ data, onLiveChange, onDownloadChart }) => {
  const { perfilcultivo: { parametros } } = data;
 const isLessThanAWeek = () => {
  const allTimestamps = parametros.flatMap(({ sensor }) =>
    sensor.valores.map(({ createdAt }) => new Date(createdAt).getTime())
  );
  if (allTimestamps.length < 2) return true;
  const min = Math.min(...allTimestamps);
  const max = Math.max(...allTimestamps);
  const diffInMs = max - min;
  return diffInMs <= 7 * 24 * 60 * 60 * 1000;
};
  const showRawTimestamps = isLessThanAWeek();
  const stored = localStorage.getItem('isLive');
  const [sizeGraph] = useState(() => {
    const width = window.innerWidth;
    if (width > 1000) return { width: 1200, height: 500 };
    if (width > 600) return { width: 700, height: 400 };
    return { width: 350, height: 300 };
  });
  const roundToMinute = (date) => {
    return new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes()
    ).getTime();
  };
  const allSeries = parametros.map(({ sensor }) => {
    const isAreaSensor = sensor.tipoSensor.nombre === 'Luz';
    return {
      name: sensor.nombre,
      type: isAreaSensor ? 'area' : 'spline',
      data: sensor.valores
        .map(({ createdAt, valor }) => {
          const date = new Date(createdAt);
          const x = showRawTimestamps
          ? roundToMinute(date)
          : new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
          return [x, valor];
        }),
        marker: {
          enabled: !isAreaSensor,
        },
    };
  });
  const chartOptions = {
    chart: {
      type: 'spline',
      height: sizeGraph.height,
      width: sizeGraph.width,
    },
    title: {
      text: null,
    },
    xAxis: {
      type: 'datetime',
      crosshair: {
        color: '#ccc',
        width: 1,
        dashStyle: 'Solid',
      },
      title: {
        text: null,
      },
    },
    tooltip: {
      shared: true,
      split: false,
      useHTML: true,
      xDateFormat: '%A, %b %e, %H:%M',
    },
    plotOptions: {
      series: {
        marker: {
          enabled: true,
          radius: 4,
          states: {
            hover: {
              enabled: true,
            },
          },
        },
        connectNulls: false,
        dataLabels: {
          enabled: false,
        },
      },
    },
    series: allSeries,
  };

  const downLoadChart = () => {
    onDownloadChart();
  };
  return (
    <Card className="chart">
      {allSeries.length > 0 ? (
        <div style={{ display: 'flex', flexDirection:'column' }}>
        <div>
          <HighchartsReact highcharts={Highcharts} options={chartOptions} />
        </div>
        <div style={{ marginTop: 24,display:'flex',alignItems:'center', justifyContent:'end',gap:'20px', marginInline:'5%' }}>
        <Checkbox
        defaultChecked={stored === 'true'}
        onChange={(e) => onLiveChange(e.target.checked)}
>
  Live
</Checkbox>
<ButtonComponent
              type="primary"
              onClick={downLoadChart}
              text="Exportar valores"
            />
</div>
        </div>
      ) : (
        <p className="messege-not-content">No hay registros almacenados</p>
      )}
    </Card>
  );
};

ChartReport.propTypes = {
  data: PropTypes.shape(),
  onLiveChange: PropTypes.func,
  onDownloadChart: PropTypes.func,
};

ChartReport.defaultProps = {
  data: {},
  onLiveChange: () => {},
  onDownloadChart: () => {}
};

export default ChartReport;
